import { render, staticRenderFns } from "./updateIssue.vue?vue&type=template&id=3db3595e&"
import script from "./updateIssue.vue?vue&type=script&lang=ts&"
export * from "./updateIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports